var _path, _circle, _path2, _circle2, _path3, _circle3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgList = function SvgList(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#2A2F3C",
    d: "M9 5.5h11"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 5.5,
    r: 1,
    stroke: "#2A2F3C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#2A2F3C",
    d: "M9 12h11"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 12,
    r: 1,
    stroke: "#2A2F3C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#2A2F3C",
    d: "M9 18.5h11"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 18.5,
    r: 1,
    stroke: "#2A2F3C"
  })));
};
export default SvgList;